var _rect, _rect2, _text, _text2, _rect3, _circle, _path, _text3, _text4, _rect4, _text5, _circle2, _text6, _rect5, _text7, _circle3, _text8, _rect6, _text9, _circle4, _text0, _rect7, _text1, _circle5, _text10, _path2, _text11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreFuelTransactionEvidenceRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 560,
    height: 570,
    viewBox: "0 0 560 570",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore refuelling evidence record") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 570,
    rx: 30,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 558,
    height: 568,
    rx: 29,
    fill: "none",
    stroke: "#55708F",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 48,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    textAnchor: "start",
    letterSpacing: 2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34,
    dy: 0
  }, "FUEL EVENT"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 86,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 830,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34,
    dy: 0
  }, "Evidence record #FC-8241"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 112,
    width: 492,
    height: 64,
    rx: 15,
    fill: "#07152A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 144,
    r: 11,
    fill: "#30D6A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m61 144 4 4 7-9",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 140,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "COMPLETE TRANSACTION")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 160,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "All required evidence linked")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 198,
    width: 492,
    height: 54,
    rx: 13,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 230,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "DRIVER")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 225,
    r: 5,
    fill: "#30D6A1"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 230,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Verified")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 266,
    width: 492,
    height: 54,
    rx: 13,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 298,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "VEHICLE")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 293,
    r: 5,
    fill: "#087CFF"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 298,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "FC\u20132047")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 334,
    width: 492,
    height: 54,
    rx: 13,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 366,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "ODOMETER")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 361,
    r: 5,
    fill: "#087CFF"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 366,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "51 284 km")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 402,
    width: 492,
    height: 54,
    rx: 13,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 434,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "FUEL ADDED")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 429,
    r: 5,
    fill: "#FF2775"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 434,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "63.2 L")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 497H503",
    stroke: "#D2E1F2",
    strokeWidth: 2,
    strokeDasharray: "5 7"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 535,
    fill: "#536985",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Driver \xB7 Vehicle \xB7 Mileage \xB7 Litres")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreFuelTransactionEvidenceRecord);
export default __webpack_public_path__ + "static/media/fleetcore-fuel-transaction-evidence-record.e09403a2cfcdb7f8bd0c93f5939e729a.svg";
export { ForwardRef as ReactComponent };